import {
  faAddressCard as fasAddressCard,
  faAngleDown as fasAngleDown,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faAngleUp as fasAngleUp,
  faArrowCircleUp as fasArrowCircleUp,
  faAsterisk as fasAsterisk,
  faBars as fasBars,
  faBullhorn as fasBullhorn,
  faCarAlt as fasCarAlt,
  faCaretUp as fasCaretUp,
  faCaretRight as fasCaretRight,
  faCaretDown as fasCaretDown,
  faCaretLeft as fasCaretLeft,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faCheckSquare as fasCheckSquare,
  faChevronCircleDown as fasChevronCircleDown,
  faCircleNotch as fasCircleNotch,
  faClock as fasClock,
  faCopy as fasCopy,
  faCreditCard as fasCreditCard,
  faEdit as fasEdit,
  faEnvelope as fasEnvelope,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faEquals as fasEquals,
  faEye as fasEye,
  faFile as fasFile,
  faFileAlt as fasFileAlt,
  faFilePrescription as fasFilePrescription,
  faFolderOpen as fasFolderOpen,
  faHeadset as fasHeadset,
  faHome as fasHome,
  faInfoCircle as fasInfoCircle,
  faLayerGroup as fasLayerGroup,
  faList as fasList,
  faListOl as fasListOl,
  faMinus as fasMinus,
  faMinusCircle as fasMinusCircle,
  faPaperPlane as fasPaperPlane,
  faPencilAlt as fasPencil,
  faPlus as fasPlus,
  faPlusCircle as fasPlusCircle,
  faPrint as fasPrint,
  faQuestion as fasQuestion,
  faQuestionCircle as fasQuestionCircle,
  faSearch as fasSearch,
  faSpinner as fasSpinner,
  faSquare as fasSquare,
  faStar as fasStar,
  faTimes as fasTimes,
  faTimesCircle as fasTimesCircle,
  faTrashAlt as fasTrashAlt,
  faUsers as fasUsers
} from "@fortawesome/free-solid-svg-icons";
import {
  faAddressCard as farAddressCard,
  faAngleDown as farAngleDown,
  faAngleLeft as farAngleLeft,
  faAngleRight as farAngleRight,
  faAngleUp as farAngleUp,
  faArrowCircleUp as farArrowCircleUp,
  faAsterisk as farAsterisk,
  faBullhorn as farBullhorn,
  faBars as farBars,
  faCarAlt as farCarAlt,
  faCaretUp as farCaretUp,
  faCaretRight as farCaretRight,
  faCaretDown as farCaretDown,
  faCaretLeft as farCaretLeft,
  faCheck as farCheck,
  faCheckCircle as farCheckCircle,
  faCheckSquare as farCheckSquare,
  faChevronCircleDown as farChevronCircleDown,
  faCircleNotch as farCircleNotch,
  faClock as farClock,
  faCopy as farCopy,
  faCreditCard as farCreditCard,
  faEdit as farEdit,
  faEnvelope as farEnvelope,
  faExclamationCircle as farExclamationCircle,
  faExclamationTriangle as farExclamationTriangle,
  faEquals as farEquals,
  faEye as farEye,
  faFile as farFile,
  faFileAlt as farFileAlt,
  faFilePrescription as farFilePrescription,
  faFolderOpen as farFolderOpen,
  faHeadset as farHeadset,
  faHome as farHome,
  faInfoCircle as farInfoCircle,
  faLayerGroup as farLayerGroup,
  faList as farList,
  faListOl as farListOl,
  faMinus as farMinus,
  faMinusCircle as farMinusCircle,
  faPaperPlane as farPaperPlane,
  faPencilAlt as farPencil,
  faPlus as farPlus,
  faPlusCircle as farPlusCircle,
  faPrint as farPrint,
  faQuestion as farQuestion,
  faSearch as farSearch,
  faSpinner as farSpinner,
  faSpinnerThird as farSpinnerThird,
  faSquare as farSquare,
  faStar as farStar,
  faTimes as farTimes,
  faTimesCircle as farTimesCircle,
  faTrashAlt as farTrashAlt,
  faUsers as farUsers
} from "@fortawesome/pro-regular-svg-icons";

import {
  faCheckSquare as fapCheckSquare,
  faSquare as fapSquare
} from "@fortawesome/pro-light-svg-icons";

export default {
  farAddressCard,
  fasAddressCard,
  farAngleDown,
  fasAngleDown,
  farAngleLeft,
  fasAngleLeft,
  farAngleRight,
  fasAngleRight,
  farAngleUp,
  fasAngleUp,
  fasArrowCircleUp,
  farArrowCircleUp,
  farAsterisk,
  fasAsterisk,
  farBars,
  fasBars,
  fasBullhorn,
  farBullhorn,
  fasCarAlt,
  farCarAlt,
  fasCaretUp,
  farCaretUp,
  fasCaretRight,
  farCaretRight,
  fasCaretDown,
  farCaretDown,
  fasCaretLeft,
  farCaretLeft,
  fasCheck,
  farCheck,
  fasCheckCircle,
  farCheckCircle,
  fasCheckSquare,
  farCheckSquare,
  fapCheckSquare,
  fasChevronCircleDown,
  farChevronCircleDown,
  fasCircleNotch,
  farCircleNotch,
  fasClock,
  farClock,
  fasCopy,
  farCopy,
  fasCreditCard,
  farCreditCard,
  fasEdit,
  farEdit,
  fasEnvelope,
  farEnvelope,
  fasExclamationCircle,
  farExclamationCircle,
  fasExclamationTriangle,
  farExclamationTriangle,
  fasEquals,
  farEquals,
  fasEye,
  farEye,
  fasFile,
  farFile,
  fasFileAlt,
  farFileAlt,
  fasFilePrescription,
  farFilePrescription,
  fasFolderOpen,
  farFolderOpen,
  fasHeadset,
  farHeadset,
  fasHome,
  farHome,
  fasInfoCircle,
  farInfoCircle,
  fasLayerGroup,
  farLayerGroup,
  fasList,
  farList,
  fasListOl,
  farListOl,
  fasMinus,
  farMinus,
  fasMinusCircle,
  farMinusCircle,
  fasPaperPlane,
  farPaperPlane,
  fasPencil,
  farPencil,
  fasPlus,
  farPlus,
  fasPlusCircle,
  farPlusCircle,
  fasPrint,
  farPrint,
  fasQuestion,
  farQuestion,
  fasQuestionCircle,
  fasSearch,
  farSearch,
  farSpinner,
  fasSpinner,
  farSpinnerThird,
  fasSquare,
  farSquare,
  fapSquare,
  fasStar,
  farStar,
  fasTimes,
  farTimes,
  fasTimesCircle,
  farTimesCircle,
  fasTrashAlt,
  farTrashAlt,
  fasUsers,
  farUsers
};
